export const validateRegex = (value: string, regex: string) => {
  const reg = new RegExp(regex);
  return reg.test(value);
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/validateRegex.ts